import { useState, createContext, useEffect } from 'react';

import { ServLoginCheck } from '../servicos/login_check'
// import { saveUserInfo } from '../util/informacoes_usuario';
import { ServGetTokenHttpOnly, servValidacaoToken } from '../servicos/servicosEmRotasPrivadas/login';

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {

    console.log('!!! Iniciando AuthProvider !!!');

    const [loading, setLoading] = useState(true);
    const [logado, setLogado] = useState(false);
    const [permissoes, setPermissoes] = useState([]);
    const [superUser, setSuperUser] = useState(false);

    console.log('loading', loading);
    console.log('logado', logado);
    console.log('permissoes', permissoes);
    console.log('superUser', superUser);

    useEffect(() => {

        async function loadUserInfo() {

            console.log('Verificando informações do usuário');

            let isLogado = false;
            let infoSMS = null;

            try {
                console.log('Login Check');
                const { data } = await ServLoginCheck();
                isLogado = data.status
                infoSMS = data
            } catch (erro) {
                console.error(erro);
                setLoading(false)
                return
            }

            // o state 'logado' já inicia com false, entao só precisa setar se for true
            if (isLogado) {

                console.log('Está logado!');
                let validacaoToken = null;
                let infoGetTokenNTM = null;

                try {
                    console.log('Validando o token');
                    validacaoToken = await servValidacaoToken()
                } catch (error) {
                    console.error('Não foi possível validar o token HTTP-Only:', error);
                }

                if (validacaoToken) {
                    console.log('Token válido');
                    setSuperUser(validacaoToken.data.superUser)
                    setPermissoes(validacaoToken.data.permissoes)
                    // setRoles(validacaoToken.data.roles)
                } else {
                    // pegando token novo
                    try {
                        console.log('Token inválido, vamos pegar um novo');
                        infoGetTokenNTM = await ServGetTokenHttpOnly(infoSMS.tokenAcesso);
                        console.log('Informações do novo token:', infoGetTokenNTM);
                        setSuperUser(infoGetTokenNTM.data.superUser)
                        setPermissoes(infoGetTokenNTM.data.permissoes)
                        console.log('Consegui pegar um token novo');
                        
                    } catch (error) {
                        console.error('Não foi possível obter o token HTTP-Only:', error);
                        setLoading(false)
                        // Desistindo do fluxo caso nao consiga pegar o tokenNTM
                        return
                    }

                }

                console.log('Fechando verificações');

            }

            setLogado(isLogado);
            setLoading(false);

        }

        loadUserInfo();

    }, []);

    return (

        <AuthContext.Provider value={
            {
                signed: !!logado,
                loading,
                permissoes: permissoes,
                // userRoles: roles,
                superUser: superUser
            }
        }>
            {/* o !!logado acima eh apenas pra forcar o valor como bool */}
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;
